import React from 'react'
import { withTranslation } from 'react-i18next'

const DEFAULT_TYPES = [
  { key: 'fuel_voucher', count: 0, percent: 0 },
  { key: 'grocery_gift_card', count: 0, percent: 0 },
  { key: 'cash_transfer', count: 0, percent: 0 },
  { key: 'television', count: 0, percent: 0 },
  { key: 'smartphone', count: 0, percent: 0 }
]

export default withTranslation()(function TopPrizeTypeCard({ t, types = DEFAULT_TYPES }) {
  return (
    <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4 flex flex-col gap-3">
      <p className="text-sm font-semibold text-dark-blue tracking-wide uppercase">{t('payout.top_prize_type.title')}</p>

      <div className="flex flex-col">
        {
          types.map(({ key, count, percent }, index) => (
            <div
              key={key}
              className={`flex items-center justify-between gap-4 py-2.5 ${index < types.length - 1 ? 'border-b border-border-lines' : ''}`}
            >
              <p className="text-sm text-secondary">{t(`payout.top_prize_type.types.${key}`)}</p>
              <p className="text-sm text-dark-blue">{`${count} (${percent}%)`}</p>
            </div>
          ))
        }
      </div>
    </div>
  )
})
